// extracted by mini-css-extract-plugin
export default {"details":"jIeZxgw98S","details-code":"LBYWs4N3Ck","detailsCode":"LBYWs4N3Ck","details-button":"Vi_mAca99z","detailsButton":"Vi_mAca99z"};